export var DraggableTypes;
(function (DraggableTypes) {
    DraggableTypes["test"] = "TEST";
    DraggableTypes["order"] = "ORDER";
})(DraggableTypes || (DraggableTypes = {}));
